import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { showErrorToast } from "../../../fnx/showError";
export var useInsurancePoliciesErrorHandling = function (_a) {
    var errorCancelPolicy = _a.errorCancelPolicy, errorDeleteEntity = _a.errorDeleteEntity, errorSponsor = _a.errorSponsor, errorPlan = _a.errorPlan, errorProject = _a.errorProject, errorGetCatalogStatusQuote = _a.errorGetCatalogStatusQuote, errorAllQuote = _a.errorAllQuote, errorBranches = _a.errorBranches, errorGetCatalogsType = _a.errorGetCatalogsType, setSeeToast = _a.setSeeToast;
    var t = useTranslation().t;
    useEffect(function () {
        if (errorCancelPolicy) {
            showErrorToast(errorCancelPolicy, setSeeToast, t);
        }
    }, [errorCancelPolicy, setSeeToast, t]);
    useEffect(function () {
        if (errorDeleteEntity) {
            showErrorToast(errorDeleteEntity, setSeeToast, t);
        }
    }, [errorDeleteEntity, setSeeToast, t]);
    useEffect(function () {
        if (errorSponsor) {
            showErrorToast(errorSponsor, setSeeToast, t);
        }
    }, [errorSponsor, setSeeToast, t]);
    useEffect(function () {
        if (errorPlan) {
            showErrorToast(errorPlan, setSeeToast, t);
        }
    }, [errorPlan, setSeeToast, t]);
    useEffect(function () {
        if (errorProject) {
            showErrorToast(errorProject, setSeeToast, t);
        }
    }, [errorProject, setSeeToast, t]);
    useEffect(function () {
        if (errorGetCatalogStatusQuote) {
            showErrorToast(errorGetCatalogStatusQuote, setSeeToast, t);
        }
    }, [errorGetCatalogStatusQuote, setSeeToast, t]);
    useEffect(function () {
        if (errorAllQuote) {
            showErrorToast(errorAllQuote, setSeeToast, t);
        }
    }, [errorAllQuote, setSeeToast, t]);
    useEffect(function () {
        if (errorBranches) {
            showErrorToast(errorBranches, setSeeToast, t);
        }
    }, [errorBranches, setSeeToast, t]);
    useEffect(function () {
        if (errorGetCatalogsType) {
            showErrorToast(errorGetCatalogsType, setSeeToast, t);
        }
    }, [errorGetCatalogsType, setSeeToast, t]);
};
